import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserService } from '../../../shared-components/user/user.service';

@Component({
  selector: 'app-welcome-modal',
  templateUrl: './welcome-modal.component.html',
  styleUrls: ['./welcome-modal.component.css']
})
export class WelcomeModalComponent implements OnInit {

  constructor(
    private dialog: MatDialogRef<WelcomeModalComponent>,
    private userService: UserService
  ) { }

  ngOnInit() {
  }

  closeClick() {
    this.userService.markWelcomeAsSeen(this.userService.currentUser.StudentId).subscribe(response => {
      if (response.ok) {
        this.dialog.close();
      }
    });
  }
}
